export default "__VITE_ASSET__185d1df5__"